(() => {
  'use strict';
  const dialog = document.getElementById('HeftyNewsletter');
  const form = document.getElementById('HeftyNewsletterForm');
  if (!dialog || !form || typeof dialog.showModal !== 'function') return;
  const keys = { dismissed: 'hefty_newsletter_dismissed_until_v1', shown: 'hefty_newsletter_shown_v1', pending: 'hefty_newsletter_pending_v1' };
  const read = (store, key) => { try { return window[store].getItem(key); } catch (_) { return null; } };
  const write = (store, key, value) => { try { window[store].setItem(key, value); } catch (_) { /* The form still works when storage is unavailable. */ } };
  const rememberClose = () => write('localStorage', keys.dismissed, String(Date.now() + 14 * 24 * 60 * 60 * 1000));
  const visible = element => !!element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none';
  const consentPending = () => {
    if (Array.from(document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')).some(visible)) return true;
    // The legacy theme's consent banner can expose only a privacy stub.
    // Its rendered banner is authoritative; do not wait forever for an unloaded API.
    if (document.getElementById('shopify-pc__banner')) return false;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.shouldShowBanner !== 'function') return false;
    const consent = typeof privacy.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : {};
    const hasChoice = Object.values(consent).some(value => value === 'yes' || value === 'no');
    return privacy.shouldShowBanner() && !hasChoice;
  };
  const open = () => {
    if (dialog.open) return;
    dialog.showModal();
    write('sessionStorage', keys.shown, '1');
    const feedback = dialog.querySelector('[data-hefty-newsletter-state]');
    (feedback || dialog.querySelector('[data-hefty-newsletter-close]')).focus({ preventScroll: true });
  };
  dialog.querySelectorAll('[data-hefty-newsletter-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', rememberClose);
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const items = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], input:not([type="hidden"]):not([disabled]), [tabindex="0"]')).filter(visible);
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  form.addEventListener('submit', () => write('sessionStorage', keys.pending, '1'));
  const feedback = dialog.querySelector('[data-hefty-newsletter-state]');
  if (feedback && (read('sessionStorage', keys.pending) === '1' || location.hash === '#HeftyNewsletterForm')) {
    write('sessionStorage', keys.pending, '0');
    if (feedback.dataset.heftyNewsletterState === 'success') rememberClose();
    open();
    return;
  }
  if (read('sessionStorage', keys.shown) === '1' || Number(read('localStorage', keys.dismissed)) > Date.now()) return;
  let clearSince = Date.now();
  const started = Date.now();
  const timer = setInterval(() => {
    const active = document.activeElement;
    const busy = consentPending() || document.hidden || (active && active.matches('input, textarea, select, [contenteditable="true"]')) || document.querySelector('dialog[open], .drawer--is-open');
    if (busy) clearSince = Date.now();
    if (!busy && Date.now() - clearSince >= 12000) { clearInterval(timer); open(); }
    if (Date.now() - started >= 240000) clearInterval(timer);
  }, 500);
})();
